export const CallbackProcessingErrorName = 'CallbackProcessingError';
export default class CallbackProcessingError extends Error {
  constructor(message: string) {
    super(`Error thrown while processing events in callback: ${message}`);
    this.name = CallbackProcessingErrorName;
  }
}
